/* tslint:disable */
import { Coordinates } from './coordinates';

/**
 */
export class ViewHeatExchange {
    result?: Coordinates;
    curve?: Coordinates;
    imageHeatExchange?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-heat-exchange.ts